import React from 'react';
// import logo from './logo.svg';

import Start from './views/start';
import List from './views/list';
import Contact from './views/contact';

function App() {
  return (
    <main className="App">
      {/* <header className="App-header"> */}
      {/* </header> */}
      {/* <Start /> */}
      <List />
      <Contact />
    </main>
  );
}

export default App;
